import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import UserContext from '../tools/contextLib'
import { browserName, browserVersion } from 'react-device-detect';
import LoadingSpin from "react-loading-spin";
import { connect } from 'react-redux';
//import store from './store';

class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        //this.toggle = this.toggle.bind(this);//Anything in here with toggle in it is a relic from when the level dropdown was in here, at first by design and then for testing. 
                                             //It can be removed since this page has almost nothing on it by design now.
        this.state = {
            loading: true,
            returnable: this.props.reduxData.userInfo,
            //selectable: ["3", "4"],//This is another relic of the days when the dropdown was in here
            level: [],
            globalLevel: "",
            ip: "",
            browser: `${browserName}${browserVersion}`,
            username: "",
            bearerVAR: "Bearer " + this.props.reduxData.apiKey
        };
        //this.getData();
        //console.log("redux user data in constructor: ", this.props.reduxData.userInfo)
    }
    //toggle() {
    //    this.setState(prevState => ({
    //        dropdownOpen: !prevState.dropdownOpen
    //    }));
    //}

    componentDidMount() {
        this.setState({
            returnable: this.props.reduxData.userInfo,
            username: this.props.reduxData.userInfo.username
        })
        //console.log("bearer token ", this.props.reduxData.apiKey)
        //console.log("redux", this.props.reduxData)
        //console.log("redux user data: ", this.props.reduxData.userInfo)
    }

    async getData() { //This chain of functions is used pretty much exclusively for logging purposes in this component
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        }, () => { this.getUserInfo(); })
        
        
    }

    //async recordComingHere() { //An interesting thing about the logging functions is that it seems to fire around three to five times every time a component loads, but 
    //                           //only the last time does it actually have all the information it needs to have. Figuring out why should be on the list of things to do.
    //                           //For the moment, it's controlled by ignoring logging fetches that don't have all the important information on the controller level
    //     let toSend = {
    //         pagePK: "1",
    //         department: this.props.reduxData.userInfo.level,
    //         userPCID: this.props.reduxData.userInfo.pcid,
    //         ip: this.state.ip,
    //         browser: this.state.browser,
    //         userID: this.props.reduxData.userInfo.username
    //    }
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //     const response = await fetch('logging', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //         body: JSON.stringify(toSend)
    //     });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //console.log("Home getUserInfo bearerVAR: " + bearerVAR)
        const response = await fetch('user', {
            method: 'GET',
            headers: { 'Authorization': bearerVAR }
        });
        const data = await response.json();
        //console.log("redux store as read from home" , this.props.reduxData)
        this.setState({
            //returnable: data,
            returnable: this.props.reduxData.userInfo,
            loading: false,
            //selectables: data.values,
            //selectables: this.props.reduxData.userInfo.values,
            //username: data.username
            username: this.props.reduxData.userInfo.username
        });//20230509: moving this.recordComingHere(); into a this.setState({}) callback to try and make sure we're always logging when there's data to log
        //localStorage.setItem("lastFetch", moment());
        this.props.updateFetchTime()
    }

    render() {
        return (
            <UserContext.Consumer>
                {contextData => (
                    <div>
                        {contextData[1] != "" && contextData[1] != null
                            ? <div><h1>Hello, {contextData[1]}. You're looking good today.</h1><p /><span className="homeSubheading">Select an item in the menu beneath the Hood shield to begin.</span></div>
                            : <LoadingSpin size="30px" primaryColor="#86d3ff" />}<br />
                        <br />
                        {/*{(this.props.reduxData.userInfo.level.pk == 3 ||*/}
                        {/*    this.props.reduxData.userInfo.level.pk == 4 ||*/}
                        {/*    this.props.reduxData.userInfo.level.pk == 282) &&*/}
                        {/*    <div>*/}
                        {/*        <Card style={{ width: '20rem' }} color="danger">*/}
                        {/*            <CardBody>*/}
                        {/*                <CardTitle tag="h5"><GoAlert /><p />Alert! DPRs are no longer in use</CardTitle>*/}
                        {/*                <CardBody>If you came here to view your DPR, turn back! <br />*/}
                        {/*                    Academic Plans are here and are available on SelfService.<br />*/}
                        {/*                    <a href="https://selfservice.hood.edu">Click Here</a> to go to SelfService and view them.*/}
                        {/*                </CardBody>*/}
                        {/*            </CardBody>*/}
                        {/*        </Card>*/}
                        {/*    </div>}*/}
                    </div>)}
            </UserContext.Consumer>
        );//contextData[1] should be the user's display name
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(Home);
